import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { isSame } from "./utils/isSame";
import { shiftList, getShift, hasShifted } from "./utils/shiftList";

function handleEditProjectRequest(
  list: Identifiable<List>,
  req: Boundaries["editProject"]["request"],
): Identifiable<List> {
  return isSame(req.nextProject.rootList, list)
    ? hasShifted(list, { ...list, ...req.nextProject.rootList })
      ? shiftList(
          {
            ...list,
            name: req.nextProject.rootList.name,
            description: req.nextProject.rootList.description,
            startDate: req.nextProject.rootList.startDate,
            endDate: req.nextProject.rootList.endDate,
          },
          getShift(list, {
            ...list,
            name: req.nextProject.rootList.name,
            description: req.nextProject.rootList.description,
            startDate: req.nextProject.rootList.startDate,
            endDate: req.nextProject.rootList.endDate,
          }),
        )
      : {
          ...list,
          name: req.nextProject.rootList.name,
          description: req.nextProject.rootList.description,
          startDate: req.nextProject.rootList.startDate,
          endDate: req.nextProject.rootList.endDate,
        }
    : {
        ...list,
        subLists: list.subLists.map((subList) =>
          handleEditProjectRequest(subList, req),
        ),
      };
}

function handleEditProjectSuccess(
  list: Identifiable<List>,
  req: Boundaries["editProject"]["success"],
): Identifiable<List> {
  return isSame(req.rootList, list)
    ? hasShifted(list, { ...list, ...req.rootList })
      ? shiftList(
          {
            ...list,
            name: req.rootList.name,
            description: req.rootList.description,
            startDate: req.rootList.startDate,
            endDate: req.rootList.endDate,
          },
          getShift(list, {
            ...list,
            name: req.rootList.name,
            description: req.rootList.description,
            startDate: req.rootList.startDate,
            endDate: req.rootList.endDate,
          }),
        )
      : {
          ...list,
          name: req.rootList.name,
          description: req.rootList.description,
          startDate: req.rootList.startDate,
          endDate: req.rootList.endDate,
        }
    : {
        ...list,
        subLists: list.subLists.map((subList) =>
          handleEditProjectSuccess(subList, req),
        ),
      };
}

function handleEditProjectFailure(
  list: Identifiable<List>,
  req: Boundaries["editProject"]["failure"],
): Identifiable<List> {
  return isSame(req.project.rootList, list)
    ? hasShifted(list, req.project.rootList)
      ? shiftList(req.project.rootList, getShift(list, req.project.rootList))
      : {
          ...list,
          name: req.project.rootList.name,
          description: req.project.rootList.description,
          startDate: req.project.rootList.startDate,
          endDate: req.project.rootList.endDate,
        }
    : {
        ...list,
        subLists: list.subLists.map((subList) =>
          handleEditProjectFailure(subList, req),
        ),
      };
}

export {
  handleEditProjectRequest,
  handleEditProjectSuccess,
  handleEditProjectFailure,
};
